export default "__VITE_ASSET__CHA16yO4__"